<div class="excel-column">
    <button mat-raised-button color="accent" class="clear" (click)="excelColumnsService.clearAllValues()">
        Limpiar
    </button>
    <div class="columns-list">
        <table mat-table [dataSource]="excelColumnsService.excelColumnViewData" class="mat-elevation-z8">
          <caption></caption>
            <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on the row definition" -->

            <!-- Position Column -->
            <ng-container matColumnDef="label">
                <th mat-header-cell *matHeaderCellDef> No. </th>
                <td mat-cell *matCellDef="let element"> {{element.label}} </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="campo">
                <th mat-header-cell *matHeaderCellDef> Name </th>
                <td mat-cell *matCellDef="let element">
                    <mat-form-field appearance="fill">
                        <mat-select [(ngModel)]="element.campo">
                            <mat-option *ngFor="let option of dropDownOptions" [value]="option">
                                {{option}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <button mat-button>
                        <mat-icon (click)="excelColumnsService.clearSingleValue(element)">clear</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
</div>